var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJoinUsHeader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1996,
    height: 353,
    viewBox: "0 0 1996 353",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_259_4205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M528.465 231.168C551.511 231.572 563.801 240.768 563.494 258.732C563.139 278.9 551.193 290.766 522.338 290.264H22V264.99H525.046C531.981 265.112 535.118 263.104 535.216 257.949C535.301 252.94 532.226 250.822 525.303 250.712L473.819 249.818C449.497 249.389 438.519 237.866 438.813 220.931C439.132 202.379 451.225 190.513 479.933 191.015L562.098 192.448L542.837 217.735L477.213 216.584C470.425 216.461 467.141 218.176 467.055 223.184C466.969 228.192 470.192 230.164 476.98 230.274L528.465 231.168Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_259_4205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M661.077 264.239L611.577 263.369L611.136 288.546L582 288.031L582.882 237.678L664.349 239.099C673.403 239.258 678.709 234.789 678.831 228.017C678.954 221.098 673.795 216.739 664.741 216.58L583.274 215.159L603.099 189.885L662.499 190.926C691.77 191.44 708.629 206.759 708.237 228.69C707.857 250.475 690.483 264.753 661.077 264.239Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_259_4205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M755.584 288.558L773.705 263.541L797.463 263.957C803.123 264.055 809.764 264.178 814.286 264.545C811.798 260.97 807.951 254.859 804.912 250.096L788.396 223.744L742.841 288.338L708.191 287.738L770.422 199.718C774.477 194.049 780.371 188.844 789.56 189.004C798.333 189.163 804.042 194.122 808.037 200.367L865.599 290.481L755.572 288.558H755.584Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_259_4205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M993.855 264.901L974.606 289.893L927.091 289.061C894.279 288.485 870.472 266.419 870.975 237.863C871.477 209.001 896.006 189.996 928.818 190.571L995.153 191.735L975.892 217.021L928.377 216.189C912.535 215.907 900.491 225.569 900.233 239.7C899.988 253.684 911.555 263.456 927.544 263.737L993.879 264.901H993.855Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_259_4205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1132.91 264.815L1113.66 289.808L1022.58 288.216L1024.29 189.714L1133.9 191.624L1114.51 216.911L1053.27 215.845L1053.06 227.626L1128.02 228.936L1110.81 251.026L1052.68 250.01L1052.45 263.407L1132.92 264.815H1132.91Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_259_4205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1260.98 264.753L1241.59 289.746L1158 288.289L1159.72 189.787L1188.99 190.301L1187.71 263.48L1260.97 264.766L1260.98 264.753Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_259_4205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1315.39 288.558L1333.51 263.541L1357.27 263.957C1362.93 264.055 1369.57 264.178 1374.09 264.545C1371.61 260.97 1367.76 254.859 1364.72 250.096L1348.2 223.744L1302.65 288.338L1268 287.738L1330.23 199.718C1334.29 194.049 1340.18 188.844 1349.37 189.004C1358.14 189.163 1363.85 194.122 1367.85 200.367L1425.41 290.481L1315.38 288.558H1315.39Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_259_4205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1555.13 261.484C1554.85 277.832 1546 290.041 1516.16 289.526L1433 288.069L1434.04 228.14L1517.76 229.597C1522 229.671 1526 228.116 1526.08 223.12C1526.17 218.258 1522.09 216.715 1517.98 216.642L1434.26 215.185L1454.52 189.91L1973.8 191V220.671C1973.8 220.903 1553.9 218.687 1553.9 218.895C1553.69 230.528 1547.22 236.896 1540.66 239.283C1548.82 241.928 1555.34 249.704 1555.13 261.484ZM1463.1 249.717L1462.87 263.26L1516.76 264.203C1523.12 264.313 1525.85 262.011 1525.93 257.443C1526.01 253.17 1523.36 250.77 1517 250.659L1463.12 249.717H1463.1Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_259_4205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M661.099 125.896H670.529C683.485 125.896 687.749 122.944 687.749 115.072V85.142H704.805V115.072C704.805 131.718 693.325 140 670.529 140H650.029L661.099 125.896ZM761.228 84.24C787.878 84.24 801.326 92.932 801.326 112.53C801.326 132.128 787.878 140.902 761.228 140.902C734.496 140.902 721.13 132.128 721.13 112.53C721.13 92.932 734.496 84.24 761.228 84.24ZM761.228 126.634C778.284 126.634 784.434 124.338 784.434 112.53C784.434 100.722 778.284 98.508 761.228 98.508C744.172 98.508 738.022 100.722 738.022 112.53C738.022 124.338 744.172 126.634 761.228 126.634ZM835.616 85.142V140H818.642V85.142H835.616ZM910.28 140.902C908.148 140.902 906.098 140.41 903.474 137.95L869.854 107.774V140H854.438V94.49C854.438 87.192 858.866 84.24 863.704 84.24C865.754 84.24 867.804 84.732 870.51 87.192L904.13 117.368V85.142H919.628V130.57C919.628 137.868 915.2 140.902 910.28 140.902ZM1049.29 85.142V116.056C1049.29 132.62 1037.89 140.902 1015.09 140.902C988.687 140.902 977.289 132.62 977.289 116.056V85.142H994.181V116.056C994.181 124.174 997.625 126.798 1015.09 126.798C1028.13 126.798 1032.23 123.764 1032.23 116.056V85.142H1049.29ZM1088.4 107.036H1118.25C1131.61 107.036 1138.83 112.038 1138.83 122.042C1138.83 133.276 1132.02 140 1115.29 140H1064.21L1075.11 125.896H1116.61C1120.62 125.896 1122.43 124.748 1122.43 121.878C1122.43 119.09 1120.62 117.942 1116.61 117.942H1086.76C1072.65 117.942 1066.18 111.628 1066.18 102.198C1066.18 91.866 1073.06 85.142 1089.71 85.142H1137.35L1126.45 99.41H1088.4C1084.46 99.41 1082.58 100.394 1082.58 103.182C1082.58 105.97 1084.46 107.036 1088.4 107.036ZM1281.76 140H1217.96L1228.21 125.896H1241.99C1245.27 125.896 1249.12 125.896 1251.74 126.06C1250.27 124.092 1247.97 120.73 1246.17 118.106L1236.33 103.592L1210.58 140H1190.49L1225.67 90.39C1227.96 87.192 1231.33 84.24 1236.66 84.24C1241.74 84.24 1245.1 86.946 1247.48 90.39L1281.76 140ZM1284.59 85.142H1346.91L1335.92 99.41H1316.32V140H1299.35V99.41H1273.6L1284.59 85.142Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_259_4205",
    x: 12,
    y: 185,
    width: 561.5,
    height: 119.279,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_259_4205"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_259_4205",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_259_4205",
    x: 572,
    y: 183.885,
    width: 146.244,
    height: 118.661,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_259_4205"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_259_4205",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_259_4205",
    x: 698.191,
    y: 183,
    width: 177.408,
    height: 121.48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_259_4205"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_259_4205",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_259_4205",
    x: 860.967,
    y: 184.559,
    width: 144.186,
    height: 119.335,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_259_4205"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_259_4205",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_259_4205",
    x: 1012.58,
    y: 183.714,
    width: 131.326,
    height: 120.094,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_259_4205"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_259_4205",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_259_4205",
    x: 1148,
    y: 183.787,
    width: 122.982,
    height: 119.959,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_259_4205"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_259_4205",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_259_4205",
    x: 1258,
    y: 183,
    width: 177.408,
    height: 121.48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_259_4205"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_259_4205",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_259_4205",
    x: 1423,
    y: 183.91,
    width: 560.799,
    height: 119.632,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_259_4205"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_259_4205",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_259_4205",
    x: 640.029,
    y: 78.2402,
    width: 716.881,
    height: 76.6616,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_259_4205"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_259_4205",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoinUsHeader);
export default __webpack_public_path__ + "static/media/join-us-header.c305c348ee6ed47de46282ad191cf226.svg";
export { ForwardRef as ReactComponent };